import * as yup from 'yup';
import { eCoverageType } from 'ui-toolkit/enums/eCoverageType';

const coverageTypes = Object.values(eCoverageType);

export const OwnerSellerPercentageFormValidation = () =>
  yup.object({
    ownerSellerPaidPercent: yup.number().min(0).max(100).required(),
  });

export const LenderSellerPercentageFormValidation = () =>
  yup.object({
    lenderSellerPaidPercent: yup.number().min(0).max(100).required(),
  });

export const CoverageTypeFormValidation = () =>
  yup.object({
    lenderFormType: yup.string().nullable().notRequired().oneOf(coverageTypes),
    ownerFormType: yup.string().nullable().notRequired().oneOf(coverageTypes),
  });
